import { render, staticRenderFns } from "./order-list-item-actions.vue?vue&type=template&id=2dcd75ca"
import script from "./order-list-item-actions.vue?vue&type=script&lang=js"
export * from "./order-list-item-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports